<template>
    <div>
    <Drawer :mask-closable="true" @on-close="reset()" class="demo-drawer-prime"
            title="Truck Order" v-model="$parent.addTruckOrderDrawer" width="500">
        <div slot="header">
            <strong>{{editMode?'Edit':'Add'}} Truck Order - {{moment().format('DD/MM/YYYY')}}</strong>
        </div>
        <Form :model="truckOrderForm" :rules="ruleTruckOrderForm" label-position="top" ref="truckOrderForm">
            <Row :gutter="10">
                <FormItem label="Booking Date">
                    <DatePicker type="date" v-model="truckOrderForm.bookingDate" :options="disableDate"
                                placeholder="Booking Date" format="dd/MM/yyyy" style="width: 264px"></DatePicker>
                </FormItem>
                <Col span="24">
                    <FormItem prop="transporterName" label="Transporter">
                        <Select v-model="truckOrderForm.transporterName" filterable @on-change="truckOrderForm.driverName = ''">
                            <Option v-for="(transporter,index) in transporterArr" :value="transporter.name"
                                    :label="transporter.name" :key="index">
                                <div class="ivu-select-item-div" @click="truckOrderForm.transporterId=transporter.id">
                                    {{transporter.name}}</div>
                            </Option>
                        </Select>
                    </FormItem>
                </Col>
                <Col span="24">
                    <FormItem prop="truckName" label="Truck">
                        <span slot="label">
                            Truck <Tooltip content="Add Truck" placement="right">
                                <Icon type="md-add-circle" @click="onAddTruck" size="22" style="margin-left: 4px"></Icon></Tooltip>
                        </span>
                        <Select v-model="truckOrderForm.truckName" filterable>
                            <Option v-for="(truck, index) in editMode?truckArr_inEditMode:truckArr" :value="truck.platNo"
                                    :label="truck.platNo" :key="index">
                                <div class="ivu-select-item-div"
                                     @click="truckOrderForm.truckId=truck.id">{{truck.platNo}} </div>
                            </Option>
                        </Select>
                    </FormItem>
                </Col>
                <Col span="24">
                    <FormItem prop="driverName" label="Driver">
                        <Select v-model="truckOrderForm.driverName" filterable>
                            <Option v-for="(driver, index) in editMode?driverArr_inEditMode:driverArr" :value="driver.name"
                                    :label="driver.name" :key="index">
                                <div class="ivu-select-item-div"
                                     @click="truckOrderForm.driverId=driver.id">{{driver.name}} </div>
                            </Option>
                        </Select>
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem prop="fromCity" label="Pickup City">
                        <AutoComplete v-model="truckOrderForm.fromCity" v-if="$parent.addTruckOrderDrawer"
                                      @on-search="handleCitySearch" @on-focus="cityFilter='%%'">
                            <Option v-for="(cityObj,index) in cityArr" :label="cityObj.city"
                                    :key="index" :value="cityObj.city">
                                <div class="ivu-select-item-div" @click="fromCityCode=cityObj.shortCode">{{cityObj.city}}</div>
                            </Option>
                        </AutoComplete>
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem prop="toCity" label="Drop City">
                        <AutoComplete v-model="truckOrderForm.toCity" v-if="$parent.addTruckOrderDrawer"
                                      @on-search="handleCitySearch" @on-focus="cityFilter='%%'">
                            <Option v-for="(cityObj,index) in cityArr" :label="cityObj.city"
                                    :key="index" :value="cityObj.city">
                                <div class="ivu-select-item-div" @click="toCityCode=cityObj.shortCode">{{cityObj.city}}</div>
                            </Option>
                        </AutoComplete>
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem prop="commitedWeight" label="Committed Weight">
                        <Input type="number" v-model="truckOrderForm.commitedWeight"/>
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem prop="price" label="Price/Amount">
                        <Input type="number" v-model="truckOrderForm.price"/>
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem prop="lrCommision" label="LR Commission">
                        <Input type="number" v-model="truckOrderForm.lrCommision"/>
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem prop="ewayBillNo" label="Eway Bill No.">
                        <Input v-model="truckOrderForm.ewayBillNo"/>
                    </FormItem>
                </Col>
                <Col span="24">
                    <Button v-show="!editMode" @click="addTruckOrder" type="primary" :loading="loading">
                        <span v-if="!loading">Start</span>
                        <span v-else>Loading...</span>
                    </Button>
                    <Button v-show="editMode" @click="modifyTruckOrder" type="primary">Update</Button>
                </Col>
            </Row>
        </Form>
    </Drawer>

    <add-truck ref="truck-form"></add-truck>

    </div>
</template>

<script>
  import {
    GET_UNOCCUPIED_TRUCKS,
    GET_DRIVERS_BY_TRANSPORTER_ID
  } from '../../graphql/queries/vehicle'
    import {SUBSCRIBE_UNOCCUPIED_TRUCKS} from '../../graphql/subscription/vehicle'
    import {GET_LAST_TRUCK_ORDER_NUMBER} from '../../graphql/queries/truckOrders'
    import {ADD_TRUCK_ORDER, DELETE_TRUCK_ORDER, UPDATE_TRUCK_ORDER} from '../../graphql/mutations/truckOrders'
    import { GET_TRANSPORTERS} from '../../graphql/queries/companies'
    import { SEARCH_CITY2} from '../../graphql/queries/territories'
    import AddTruck from '../Settings/AddTruck'
    import {generateUUID} from "../../Constants/Constant";
    import ValidationRules from '../../Constants/ValidationRules'
    import moment from 'moment'
    import _ from 'lodash'
    import {Constants} from "../../Constants/Constant";
    import {generate_UPDATE_ORDER_DATA} from "../../graphql/mutations/orders";

    export default {
        apollo: {
            company: {
                query: GET_TRANSPORTERS,
                result ({ data, loading }) {
                    if (!loading) {
                        this.transporterArr = data.company;
                    }
                }
            },
            unOccupiedTrucks: {
                query: GET_UNOCCUPIED_TRUCKS,
                variables(){
                    return {
                        truckIds: this.$parent.occupiedTruckIdArr,
                        transporterId: this.truckOrderForm.transporterId
                    }
                },
                subscribeToMore: {
                    document: SUBSCRIBE_UNOCCUPIED_TRUCKS,
                    variables(){return {truckIds: this.$parent.occupiedTruckIdArr, transporterId: this.truckOrderForm.transporterId}},
                    updateQuery: function(previousResult, { subscriptionData }) {
                        this.truckArr = subscriptionData.data.unOccupiedTrucks;
                        this.truckArr_inEditMode = subscriptionData.data.unOccupiedTrucks;
                    },
                },
                result ({ data, loading }) {
                    if (!loading) {
                        this.truckArr = data.unOccupiedTrucks;
                        this.truckArr_inEditMode = data.unOccupiedTrucks;
                    }
                }
            },
            driverArr: {
              query: GET_DRIVERS_BY_TRANSPORTER_ID,
              fetchPolicy: 'network-only',
              skip () {return !this.truckOrderForm.transporterId},
              variables() { return { transporterId: this.truckOrderForm.transporterId }},
            },
            city: {
                query: SEARCH_CITY2,
                variables() {
                    return {
                        cityFilter: this.cityFilter
                    }
                },
                result ({ data, loading }) {
                    if (!loading) {
                        this.cityArr = data.city;
                    }
                }
            }
        },
        name: "AddTruckOrder",
        components:{AddTruck},
        data: function(){
            return {
                Constants: Constants,
                mutation_ADD_TRUCK_ORDER: ADD_TRUCK_ORDER,
                mutation_UPDATE_TRUCK_ORDER: UPDATE_TRUCK_ORDER,
                moment: moment,
                truckOrderForm:{
                    id: '',
                    bookingDate: moment().format('DD/MM/YYYY'),
                    transporterId: 'aa00aa00-000a-0000-aaaa-aaaaaa00000a',
                    transporterName: '',
                    truckId: '',
                    truckName: '',
                    driverId: '',
                    driverName: '',
                    fromCity: '',
                    toCity: '',
                    commitedWeight: '',
                    price: '',
                    lrCommision: '',
                    ewayBillNo: ''
                },
                ruleTruckOrderForm: {
                    bookingDate: [{required: true, type: 'date', message: 'Please select Date', trigger: 'blur'}],
                    transporterName: ValidationRules.selectField,
                    truckName: ValidationRules.selectField,
                    driverName: ValidationRules.selectField,
                    fromCity: ValidationRules.textField('Pickup city'),
                    toCity: ValidationRules.textField('Drop city'),
                },
                disableDate: {disabledDate (date) {return date && date.valueOf() < Date.now() - 86400000;}},
                cityFilter: '%%',
                cityArr: [],
                transporterArr: [],
                truckArr: [],
                driverArr: [],
                truckArr_inEditMode: [],
                driverArr_inEditMode: [],
                editMode: false,
                lastTruckOrderNumber: 'TR-MOR-SUR-20191122000',
                fromCityCode: 'SUR',
                toCityCode: 'MRB',
                lastNumber: '',
                loading: false
            }
        },
        methods: {
            reset: function(){
                this.$refs['truckOrderForm'].resetFields();
            },
            handleCitySearch: _.debounce(function(val){
                this.cityFilter = '%' + val + '%'
            }, 500),
            onAddTruck(){
                this.$refs['truck-form'].onAddTruck();
            },
            setTruckOrderForm(truckOrderData){
                // this.truckArr_inEditMode = JSON.parse(JSON.stringify(this.truckArr));
                this.truckArr_inEditMode.push({id: truckOrderData.truckId, name: truckOrderData.truck.name, platNo:truckOrderData.truck.platNo})
                this.driverArr_inEditMode = JSON.parse(JSON.stringify(this.driverArr));
                this.driverArr_inEditMode.push({id: truckOrderData.driverId, name: truckOrderData.driverDetail.name})
                this.truckOrderForm.id = truckOrderData.id;
                this.lastNumber = truckOrderData.truckOrderNumber;
                this.truckOrderForm.transporterId = truckOrderData.transporterId;
                this.truckOrderForm.transporterName = truckOrderData.Transporter.name;
                this.fromCityCode = truckOrderData.pickCity.shortCode;
                this.toCityCode = truckOrderData.dropCity.shortCode;
                this.truckOrderForm.truckId = truckOrderData.truckId;
                this.truckOrderForm.truckName = truckOrderData.truck.platNo;
                this.truckOrderForm.driverId = truckOrderData.driverId;
                this.truckOrderForm.driverName = truckOrderData.driverDetail.name;
                this.truckOrderForm.fromCity = truckOrderData.fromCity;
                this.truckOrderForm.toCity = truckOrderData.toCity;
                this.truckOrderForm.commitedWeight = truckOrderData.commitedWeight;
                this.truckOrderForm.price = truckOrderData.price;
                this.truckOrderForm.lrCommision = truckOrderData.lrCommision;
                this.truckOrderForm.bookingDate = moment(truckOrderData.bookingDate, 'YYYY-MM-DD').format('DD/MM/YYYY');
                this.truckOrderForm.ewayBillNo = truckOrderData.ewayBillNo;
            },
            addTruckOrder(){
             this.loading = true
             this.$refs['truckOrderForm'].validate((valid) => {
                if (valid) {
                    this.insertTruckOrder();
                }else{
                    this.loading = false
                }
             })
            },
            generateTruckOrderNumber(){
                let lastThreeDigits = parseInt(this.lastTruckOrderNumber.substr(this.lastTruckOrderNumber.length - 3)) + 1;
                if(lastThreeDigits.toString().length == 1){
                    lastThreeDigits = '00' + lastThreeDigits
                }else if(lastThreeDigits.toString().length == 2){
                    lastThreeDigits = '0' + lastThreeDigits
                }
                return 'TR-' + this.fromCityCode + '-' + this.toCityCode + '-' + moment().format('YYYYMMDD') + lastThreeDigits;
            },
            async insertTruckOrder(){

              /* ---------- GET LAST TRUCK ORDER NUMBER ------------ */
              let res = await this.$apollo.query({
                query: GET_LAST_TRUCK_ORDER_NUMBER,
                variables: {
                  todayDate: moment().format('YYYY-MM-DD')
                },
                fetchPolicy: "network-only"
              })
              if(res.data.lastTruckOrder.length){
                this.lastTruckOrderNumber = res.data.lastTruckOrder[0].truckOrderNumber;
              }
              let truckOrderNumber = this.generateTruckOrderNumber()
              /* ---------------x---------------x--------------x------------ */


                let response = await this.$apollo.mutate({
                    mutation: this.mutation_ADD_TRUCK_ORDER,
                    variables: {
                        id: generateUUID(),
                        bookingDate: moment(this.truckOrderForm.bookingDate, 'ddd MMMM DD YYYY').format('YYYY-MM-DD'),
                        truckOrderNumber: truckOrderNumber,
                        transporterId: this.truckOrderForm.transporterId,
                        truckId: this.truckOrderForm.truckId,
                        driverId: this.truckOrderForm.driverId,
                        date: moment().format('YYYY-MM-DD'),
                        fromCity: this.truckOrderForm.fromCity,
                        toCity: this.truckOrderForm.toCity,
                        commitedWeight: this.truckOrderForm.commitedWeight,
                        price: this.truckOrderForm.price,
                        lrCommision: this.truckOrderForm.lrCommision,
                        ewayBillNo: this.truckOrderForm.ewayBillNo?this.truckOrderForm.ewayBillNo:null,
                        createdAt: moment().format(),
                        status: 'InProgress',
                        internalstatus: Constants.internalStatus.waitingForDeparture
                    }
                })
                if(response.data.insert_truckOrders.returning[0].id){
                    this.$Message.success('Truck Order placed successfully!');
                    this.reset();
                    this.loading = false
                    this.$parent.addTruckOrderDrawer = false;
                }
            },
            modifyTruckOrder(){
                this.$refs['truckOrderForm'].validate((valid) => {
                    if (valid) {
                        this.updateTruckOrder();
                    }
                })
            },
            async updateTruckOrder(){
                let response = await this.$apollo.mutate({
                    mutation: this.mutation_UPDATE_TRUCK_ORDER,
                    variables: {
                        truckOrderId: this.truckOrderForm.id,
                        truckOrderNumber: 'TR-' + this.fromCityCode + '-' + this.toCityCode + this.lastNumber.substr(10),
                        transporterId: this.truckOrderForm.transporterId,
                        truckId: this.truckOrderForm.truckId,
                        driverId: this.truckOrderForm.driverId,
                        fromCity: this.truckOrderForm.fromCity,
                        toCity: this.truckOrderForm.toCity,
                        commitedWeight: this.truckOrderForm.commitedWeight,
                        price: this.truckOrderForm.price,
                        lrCommision: this.truckOrderForm.lrCommision,
                        ewayBillNo: this.truckOrderForm.ewayBillNo?this.truckOrderForm.ewayBillNo:null,
                        bookingDate: moment(this.truckOrderForm.bookingDate, 'DD/MM/YYYY').format('YYYY-MM-DD'),
                    }
                })
                if(response.data){
                    this.$Message.success('Truck Order updated successfully!');
                    this.reset();
                    this.$parent.addTruckOrderDrawer = false;
                }
            },
          onDeleteTruckOrder(truckOrderId){
            this.$Modal.confirm({
              title: 'Confirmation',
              content: '<p>Are You sure want to delete Truck Order ?</p>',
              loading: true,
              onOk: () => {
                // this.deleteTruckOrder(truckOrderId, this.$Modal)
                let obj = {status: 'Cancel'}
                this.updateRecord(truckOrderId, obj, 'truckOrders', this.$Modal)
              }
            });
          },
          async updateRecord(id, obj, table, callback){
            let response = await this.$apollo.mutate({
              mutation: generate_UPDATE_ORDER_DATA(table),
              variables: { id: id, obj: obj}
            })
            if(response.data){
              this.$Message.success('Truck Order updated successfully!')
              callback.remove();
            }
          },
        }
    }
</script>

<style scoped>
    /deep/ .ivu-select-item{
        padding: 0px 0px;
    }
    /deep/ .ivu-select-item-div{
        width: 100%;
        padding: 7px 16px;
    }
    /deep/ .ivu-auto-complete.ivu-select-dropdown{
        max-height: 200px !important;
    }
    /deep/ .ivu-date-picker-cells{
        width: 259px !important;
    }
   /deep/ .ivu-date-picker-cells span{
        width: 37px !important;
        margin: 0;
        font-size: 15px;
    }
</style>
